<template>
  <div class="inline-block relative">
    <i class="spinning-loader fas fa-circle-notch text-green-300 text-3xl"></i>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css">
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.loader-wrapper {
  position: relative;
}
.spinning-loader {
  position: relative;
  transform-origin: center;
  animation: spin 0.8s linear infinite;
}
</style>
